import * as z from 'zod';
import { localizedTextSchema, type LocalizedTextInput } from './localized';

export const cuisineSchema = z
  .object({
    id: z.string(),
    name: localizedTextSchema,
    created_at: z.string().nullish(),
    updated_at: z.string().nullish(),
  })
  .loose();
export type Cuisine = z.infer<typeof cuisineSchema>;
export interface CuisineInput {
  name: LocalizedTextInput;
}
